/* Combi-deal configurator — rubberbotenwinkel.nl
 * Stap-voor-stap: lengte -> vloertype -> kleur -> motor -> vaarklaarpakket -> winkelwagen.
 * Alle prijzen/compatibiliteit komen uit het #combi-deal-data JSON-blok (server-side
 * gerenderd vanuit combi_deal metafields). Niets hier is hardcoded.
 *
 * i18n (sept 2026, werkkopie): alle zichtbare strings die hier dynamisch in de DOM
 * worden gezet, komen nu uit het #combi-i18n-data JSON-blok (server-side vertaald via
 * de 't' filter in combi-deal-configurator.liquid), zodat EN/DE-bezoekers ook op deze
 * pagina de juiste taal zien. Bij het ontbreken van dat blok vallen we terug op de
 * oorspronkelijke Nederlandse teksten, zodat de configurator nooit stuk kan gaan.
 */
(function () {
  'use strict';

  var root = document.getElementById('combi-configurator');
  if (!root) return;

  var dataEl = document.getElementById('combi-deal-data');
  var DATA;
  try {
    DATA = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error('Combi-deal configurator: kon data niet parsen', e);
    return;
  }

  var I18N_DEFAULTS = {
    fromPrice: 'vanaf',
    hpShort: 'pk',
    floorNames: { SL: 'Lattenbodem', AIR: 'Airdeck', AL: 'Aluminium vloer' },
    floorAirdeckSe: 'Airdeck Special Edition',
    vaarklaarLabel: 'Vaarklaarpakket',
    electricNote: 'Bij een elektromotor testen wij de accu en aandrijving voor verzending.',
    gasolineNote: 'Let op: bij een benzinemotor komt de brandstoftank leeg aan — je vult zelf brandstof bij.',
    addToCart: 'Toevoegen aan winkelwagen',
    chooseFirst: 'Kies eerst je boot en motor hierboven',
    adding: 'Bezig met toevoegen…',
    addError: 'Er ging iets mis bij het toevoegen aan de winkelwagen. Probeer het opnieuw.'
  };
  var I18N = I18N_DEFAULTS;
  var i18nEl = document.getElementById('combi-i18n-data');
  if (i18nEl) {
    try {
      var parsed = JSON.parse(i18nEl.textContent);
      I18N = {};
      Object.keys(I18N_DEFAULTS).forEach(function (key) {
        I18N[key] = (parsed[key] !== undefined && parsed[key] !== null && parsed[key] !== '') ? parsed[key] : I18N_DEFAULTS[key];
      });
    } catch (e) {
      console.warn('Combi-deal configurator: kon i18n-data niet parsen, val terug op NL', e);
    }
  }

  var FLOOR_NAMES = I18N.floorNames;
  function floorName(floor, length) {
    if (floor === 'AIR' && Number(length) === 280) return I18N.floorAirdeckSe;
    return FLOOR_NAMES[floor] || floor;
  }

  function eur(amount) {
    var n = Number(amount) || 0;
    return n.toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
  }

  function uniqBy(arr, keyFn) {
    var seen = Object.create(null);
    var out = [];
    arr.forEach(function (item) {
      var k = keyFn(item);
      if (!seen[k]) { seen[k] = true; out.push(item); }
    });
    return out;
  }

  // ---- state ----
  var state = {
    length: null,
    floor: null,
    color: null,
    boat: null, // resolved boat record
    motorVariantId: null,
    motor: null, // resolved motor record
    vaarklaar: null // 'yes' | 'no' | null
  };

  // Update 2 (sept 2026, werkkopie): onthoudt of de "toevoegen aan winkelwagen"-
  // knop de vorige keer al actief was, zodat we de pop-animatie (zie
  // combi-deal-configurator.css, .is-ready) precies één keer triggeren op het
  // moment dat hij van uit- naar aanzet springt — niet bij elke herberekening.
  var wasReady = false;

  // ---- element refs ----
  var els = {
    lengthOptions: document.getElementById('combi-length-options'),
    floorStep: root.querySelector('[data-step="floor"]'),
    floorOptions: document.getElementById('combi-floor-options'),
    colorStep: root.querySelector('[data-step="color"]'),
    colorOptions: document.getElementById('combi-color-options'),
    motorStep: root.querySelector('[data-step="motor"]'),
    motorTabs: document.getElementById('combi-motor-tabs'),
    motorOptions: document.getElementById('combi-motor-options'),
    vaarklaarStep: root.querySelector('[data-step="vaarklaar"]'),
    vaarklaarFuelNote: document.getElementById('combi-vaarklaar-fuel-note'),
    vaarklaarPrice: document.getElementById('combi-vaarklaar-price'),
    previewImage: document.getElementById('combi-preview-image'),
    previewPlaceholder: document.getElementById('combi-preview-placeholder'),
    previewCaption: document.getElementById('combi-preview-caption'),
    summaryLines: document.getElementById('combi-summary-lines'),
    summaryTotal: document.getElementById('combi-summary-total'),
    addToCart: document.getElementById('combi-add-to-cart')
  };

  var activeFuelTab = null;

  // ---- derived lookups ----
  function boatsForLength(length) {
    return DATA.boats.filter(function (b) { return Number(b.length) === Number(length); });
  }
  function floorsForLength(length) {
    var boats = boatsForLength(length);
    return uniqBy(boats, function (b) { return b.floor; }).map(function (b) { return b.floor; });
  }
  function colorsForLengthFloor(length, floor) {
    return DATA.boats.filter(function (b) {
      return Number(b.length) === Number(length) && b.floor === floor;
    });
  }
  // VEILIGHEID (sept 2026): de gecureerde lijst compatible_motor_variant_ids blijft
  // leidend, maar is mensenwerk. Een foutieve regel daarin mocht voorheen een motor
  // tonen die zwaarder is dan waar de boot voor gekeurd is (combi_deal.max_hp).
  // Daarom filteren we hier hard op het vermogen van de boot zelf: een benzinemotor
  // met meer pk dan max_hp wordt nooit aangeboden, ook niet als de lijst hem noemt.
  // Elektromotoren hebben geen powerHp (alleen powerWatt) en blijven altijd staan;
  // is max_hp niet ingevuld op de boot, dan valt dit terug op het oude gedrag.
  function motorsForBoat(boat) {
    if (!boat) return [];
    var ids = boat.motorVariantIds.map(String);
    var matched = DATA.motors.filter(function (m) { return ids.indexOf(String(m.variantId)) !== -1; });
    var maxHp = parseFloat(boat.maxHp);
    if (!isNaN(maxHp) && maxHp > 0) {
      matched = matched.filter(function (m) {
        var hp = parseFloat(m.powerHp);
        return isNaN(hp) || hp <= maxHp + 0.001;
      });
    }
    return uniqBy(matched, function (m) { return m.variantId; });
  }

  // ---- rendering: step 1 (lengte) ----
  function renderLengths() {
    var lengths = uniqBy(DATA.boats, function (b) { return b.length; })
      .map(function (b) { return Number(b.length); })
      .sort(function (a, b) { return a - b; });

    els.lengthOptions.innerHTML = '';
    lengths.forEach(function (length) {
      var boats = boatsForLength(length);
      var cheapest = boats.reduce(function (min, b) { return b.price < min.price ? b : min; }, boats[0]);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'combi-card';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.dataset.length = length;
      btn.innerHTML =
        '<span class="combi-card__image-wrap"><img class="combi-card__image" src="' + cheapest.image + '" alt="" loading="lazy" width="300" height="300"></span>' +
        '<span class="combi-card__label">' + length + ' cm</span>' +
        '<span class="combi-card__price">' + I18N.fromPrice + ' ' + eur(cheapest.price) + '</span>';
      btn.addEventListener('click', function () { selectLength(length); });
      els.lengthOptions.appendChild(btn);
    });
  }

  function markSelected(container, matchFn) {
    Array.prototype.forEach.call(container.children, function (child) {
      var isMatch = matchFn(child);
      child.classList.toggle('is-selected', isMatch);
      child.setAttribute('aria-checked', isMatch ? 'true' : 'false');
    });
  }

  function selectLength(length) {
    if (state.length === length) return;
    state.length = length;
    state.floor = null;
    state.color = null;
    state.boat = null;
    state.motorVariantId = null;
    state.motor = null;
    state.vaarklaar = null;

    markSelected(els.lengthOptions, function (c) { return Number(c.dataset.length) === Number(length); });

    hideStep(els.motorStep);
    hideStep(els.vaarklaarStep);

    var floors = floorsForLength(length);
    if (floors.length > 1) {
      renderFloors(length, floors);
      showStep(els.floorStep);
      hideStep(els.colorStep);
    } else {
      state.floor = floors[0];
      hideStep(els.floorStep);
      resolveColorStep(); // dit toont/verbergt de kleurstap zelf, afhankelijk van het aantal opties
    }
    updatePreview();
    updateSummary();
  }

  // ---- rendering: step 2 (vloertype) ----
  function renderFloors(length, floors) {
    els.floorOptions.innerHTML = '';
    floors.forEach(function (floor) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'combi-pill';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.dataset.floor = floor;
      btn.textContent = floorName(floor, length);
      btn.addEventListener('click', function () { selectFloor(floor); });
      els.floorOptions.appendChild(btn);
    });
  }

  function selectFloor(floor) {
    if (state.floor === floor) return;
    state.floor = floor;
    state.color = null;
    state.boat = null;
    state.motorVariantId = null;
    state.motor = null;
    state.vaarklaar = null;

    markSelected(els.floorOptions, function (c) { return c.dataset.floor === floor; });
    hideStep(els.motorStep);
    hideStep(els.vaarklaarStep);
    resolveColorStep();
    updatePreview();
    updateSummary();
  }

  // ---- rendering: step 3 (kleur) ----
  function resolveColorStep() {
    var options = colorsForLengthFloor(state.length, state.floor);
    if (options.length > 1) {
      renderColors(options);
      showStep(els.colorStep);
    } else {
      hideStep(els.colorStep);
      selectColor(options[0].color, options);
    }
  }

  function renderColors(options) {
    els.colorOptions.innerHTML = '';
    options.forEach(function (boat) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'combi-swatch';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.dataset.color = boat.color;
      btn.innerHTML =
        '<span class="combi-swatch__image-wrap"><img class="combi-swatch__image" src="' + boat.image + '" alt="" loading="lazy" width="120" height="120"></span>' +
        '<span class="combi-swatch__label">' + boat.color + '</span>';
      btn.addEventListener('click', function () { selectColor(boat.color, options); });
      els.colorOptions.appendChild(btn);
    });
  }

  function selectColor(color, options) {
    state.color = color;
    state.boat = (options || colorsForLengthFloor(state.length, state.floor)).filter(function (b) {
      return b.color === color;
    })[0];
    state.motorVariantId = null;
    state.motor = null;
    state.vaarklaar = null;

    if (els.colorOptions.children.length) {
      markSelected(els.colorOptions, function (c) { return c.dataset.color === color; });
    }

    renderMotors();
    showStep(els.motorStep);
    hideStep(els.vaarklaarStep);
    updatePreview();
    updateSummary();
  }

  // ---- rendering: step 4 (motor) ----
  function renderMotors() {
    var motors = motorsForBoat(state.boat);
    var fuels = uniqBy(motors, function (m) { return m.fuelType; }).map(function (m) { return m.fuelType; });

    if (fuels.length > 1) {
      els.motorTabs.hidden = false;
      activeFuelTab = fuels[0];
      Array.prototype.forEach.call(els.motorTabs.children, function (tab) {
        var isActive = tab.dataset.fuel === activeFuelTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.onclick = function () {
          activeFuelTab = tab.dataset.fuel;
          Array.prototype.forEach.call(els.motorTabs.children, function (t) {
            t.classList.toggle('is-active', t === tab);
            t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
          });
          renderMotorList(motors.filter(function (m) { return m.fuelType === activeFuelTab; }));
        };
      });
      renderMotorList(motors.filter(function (m) { return m.fuelType === activeFuelTab; }));
    } else {
      els.motorTabs.hidden = true;
      activeFuelTab = null;
      renderMotorList(motors);
    }
  }

  function motorSpecLabel(m) {
    if (m.powerHp) return m.powerHp + ' ' + I18N.hpShort;
    if (m.powerWatt) return m.powerWatt + ' W';
    return '';
  }

  function renderMotorList(motors) {
    motors.sort(function (a, b) { return a.price - b.price; });
    els.motorOptions.innerHTML = '';
    motors.forEach(function (m) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'combi-motor';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.dataset.variantId = m.variantId;
      var subtitle = m.variantTitle && m.variantTitle !== 'Default Title' ? m.variantTitle : '';
      btn.innerHTML =
        '<span class="combi-motor__image-wrap"><img class="combi-motor__image" src="' + m.image + '" alt="" loading="lazy" width="120" height="120"></span>' +
        '<span class="combi-motor__info">' +
          '<span class="combi-motor__title">' + m.productTitle + '</span>' +
          (subtitle ? '<span class="combi-motor__subtitle">' + subtitle + '</span>' : '') +
          '<span class="combi-motor__spec">' + motorSpecLabel(m) + '</span>' +
        '</span>' +
        '<span class="combi-motor__price">' + eur(m.price) + '</span>';
      btn.addEventListener('click', function () { selectMotor(m); });
      els.motorOptions.appendChild(btn);
    });
  }

  function selectMotor(motor) {
    state.motorVariantId = motor.variantId;
    state.motor = motor;
    state.vaarklaar = null;

    markSelected(els.motorOptions, function (c) { return String(c.dataset.variantId) === String(motor.variantId); });

    var isElectric = motor.fuelType === 'Elektrisch';
    els.vaarklaarFuelNote.textContent = isElectric ? I18N.electricNote : I18N.gasolineNote;
    if (DATA.vaarklaarpakket && DATA.vaarklaarpakket.price != null) {
      els.vaarklaarPrice.textContent = '+ ' + eur(DATA.vaarklaarpakket.price);
    }

    showStep(els.vaarklaarStep);
    updateSummary();
  }

  // ---- stap 5 (vaarklaarpakket) ----
  Array.prototype.forEach.call(root.querySelectorAll('.combi-vaarklaar-btn'), function (btn) {
    btn.addEventListener('click', function () {
      state.vaarklaar = btn.dataset.choice;
      Array.prototype.forEach.call(root.querySelectorAll('.combi-vaarklaar-btn'), function (b) {
        var isSel = b === btn;
        b.classList.toggle('is-selected', isSel);
        b.setAttribute('aria-checked', isSel ? 'true' : 'false');
      });
      updateSummary();
    });
  });

  // ---- step visibility helpers ----
  function showStep(el) { if (el) el.hidden = false; }
  function hideStep(el) { if (el) el.hidden = true; }

  // ---- preview image ----
  function updatePreview() {
    if (state.boat) {
      els.previewImage.src = state.boat.image;
      els.previewImage.alt = state.boat.title + ' ' + state.boat.color;
      els.previewImage.style.display = '';
      els.previewPlaceholder.style.display = 'none';
      els.previewCaption.textContent = state.boat.title + ' — ' + state.boat.color +
        (state.floor ? ' — ' + floorName(state.floor, state.length) : '');
    } else {
      els.previewImage.style.display = 'none';
      els.previewPlaceholder.style.display = '';
      els.previewCaption.textContent = '';
    }
  }

  // ---- summary / cart ----
  function updateSummary() {
    var lines = [];
    var subtotal = 0;

    if (state.boat) {
      lines.push({ label: state.boat.title + ' (' + state.boat.color + ')', price: state.boat.price });
      subtotal += Number(state.boat.price);
    }
    if (state.motor) {
      lines.push({ label: state.motor.productTitle + (state.motor.variantTitle && state.motor.variantTitle !== 'Default Title' ? ' — ' + state.motor.variantTitle : ''), price: state.motor.price });
      subtotal += Number(state.motor.price);
    }
    if (state.vaarklaar === 'yes' && DATA.vaarklaarpakket && DATA.vaarklaarpakket.price != null) {
      lines.push({ label: I18N.vaarklaarLabel, price: DATA.vaarklaarpakket.price });
      subtotal += Number(DATA.vaarklaarpakket.price);
    }

    els.summaryLines.innerHTML = lines.map(function (l) {
      return '<span class="combi-summary__line"><span>' + l.label + '</span><span>' + eur(l.price) + '</span></span>';
    }).join('');

    if (subtotal > 0) {
      var estDiscounted = subtotal * 0.9;
      els.summaryTotal.innerHTML = eur(estDiscounted) + ' <s class="combi-summary__was">' + eur(subtotal) + '</s>';
    } else {
      els.summaryTotal.textContent = eur(0);
    }

    // FIX (sept 2026, werkkopie): de knop bleef altijd de tekst "Toevoegen aan
    // winkelwagen" tonen, ook grijs/uitgeschakeld vóórdat boot + motor gekozen
    // waren — daardoor was niet duidelijk dát er nog iets gekozen moest worden
    // om hem te activeren. De knoptekst wisselt nu mee met de status.
    var canAdd = !!(state.boat && state.motor);
    els.addToCart.disabled = !canAdd;
    els.addToCart.textContent = canAdd ? I18N.addToCart : I18N.chooseFirst;

    // Update 2 (sept 2026, werkkopie): knop viel zelfs in actieve staat nog
    // niet genoeg op. Naast de goud/gloed-styling op desktop (zie
    // combi-deal-configurator.css) triggeren we hier eenmalig een "pop"-
    // animatie exact op het moment dat de knop van uit- naar aanzet springt,
    // zodat de blik er vanzelf naartoe getrokken wordt. De animatie zelf
    // wordt in CSS uitgeschakeld voor bezoekers met prefers-reduced-motion.
    if (canAdd && !wasReady) {
      els.addToCart.classList.remove('is-ready');
      void els.addToCart.offsetWidth; // forceer reflow zodat de animatie herstart
      els.addToCart.classList.add('is-ready');
    } else if (!canAdd) {
      els.addToCart.classList.remove('is-ready');
    }
    wasReady = canAdd;
  }

  els.addToCart.addEventListener('click', function () {
    if (!state.boat || !state.motor) return;
    els.addToCart.disabled = true;
    els.addToCart.textContent = I18N.adding;

    var bundleId = 'combi-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
    var items = [
      { id: state.boat.variantId, quantity: 1, properties: { _combi_bundle_id: bundleId, _combi_deal: 'Boot' } },
      { id: state.motor.variantId, quantity: 1, properties: { _combi_bundle_id: bundleId, _combi_deal: 'Motor' } }
    ];
    if (state.vaarklaar === 'yes' && DATA.vaarklaarpakket && DATA.vaarklaarpakket.variantId) {
      items.push({ id: DATA.vaarklaarpakket.variantId, quantity: 1, properties: { _combi_bundle_id: bundleId, _combi_deal: 'Vaarklaarpakket' } });
    }

    fetch(DATA.cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        window.location.href = DATA.cartUrl;
      })
      .catch(function (err) {
        console.error('Combi-deal: kon niet aan winkelwagen toevoegen', err);
        els.addToCart.disabled = false;
        els.addToCart.textContent = I18N.addToCart;
        alert(I18N.addError);
      });
  });

  // ---- deeplink: voorselectie via URL (?boot=<handle>&motor=<variant-id>) ----
  // De bootadviseur elders op de site linkt hiernaartoe met een boot-handle en een
  // motor-variant-id. We bedienen hier exact dezelfde functies als een bezoeker die
  // zelf klikt, zodat er geen afwijkende staat kan ontstaan. Alles is best-effort:
  // klopt er iets niet (onbekende handle, incompatibele of door de max_hp-check
  // geblokkeerde motor), dan stoppen we stil en staat de configurator gewoon in zijn
  // normale beginstaat — nooit een foutmelding, nooit een halve selectie.
  function applyUrlPreselection() {
    try {
      var params = new URLSearchParams(window.location.search);
      var boatHandle = params.get('boot');
      if (!boatHandle) return;

      var boat = DATA.boats.filter(function (b) { return b.handle === boatHandle; })[0];
      if (!boat) return;

      // Stap 1: lengte (selectLength negeert een herhaalde keuze zelf).
      selectLength(Number(boat.length));
      if (Number(state.length) !== Number(boat.length)) return;

      // Stap 2: vloertype — alleen als selectLength het niet al automatisch zette.
      if (state.floor !== boat.floor) {
        if (floorsForLength(Number(boat.length)).indexOf(boat.floor) === -1) return;
        selectFloor(boat.floor);
        if (state.floor !== boat.floor) return;
      }

      // Stap 3: kleur — alleen als de juiste boot nog niet automatisch gekozen is.
      if (!state.boat || String(state.boat.variantId) !== String(boat.variantId)) {
        var colorOptions = colorsForLengthFloor(state.length, state.floor);
        var colorMatch = colorOptions.filter(function (b) { return b.color === boat.color; })[0];
        if (!colorMatch) return;
        selectColor(colorMatch.color, colorOptions);
      }
      if (!state.boat) return;

      // Stap 4: motor — uitsluitend uit de lijst die deze boot daadwerkelijk mag
      // voeren (dus inclusief de max_hp-veiligheidsfilter hierboven).
      var motorParam = params.get('motor');
      if (!motorParam) return;

      var motor = motorsForBoat(state.boat).filter(function (m) {
        return String(m.variantId) === String(motorParam);
      })[0];
      if (!motor) return;

      // renderMotors toont alleen de motoren van het actieve brandstoftabblad;
      // zonder deze wissel zou de selectie niet in de DOM staan.
      if (!els.motorTabs.hidden && motor.fuelType && activeFuelTab !== motor.fuelType) {
        var tab = Array.prototype.filter.call(els.motorTabs.children, function (t) {
          return t.dataset.fuel === motor.fuelType;
        })[0];
        if (!tab) return;
        tab.click();
      }

      selectMotor(motor);
    } catch (e) {
      console.warn('Combi-deal: voorselectie via URL overgeslagen', e);
    }
  }

  // ---- init ----
  renderLengths();
  applyUrlPreselection();
  updateSummary();
})();
